export default __webpack_public_path__ + "static/media/placeholder1.dce0f0c6.jpg";